import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { InboxEntryStatus } from '../types';

export type UpdateEmailFileEntryResponse = {
  data: {
    'inbox-email': any;
    'inbox-entry': any;
    'inbox-email-attachment': any;
  };
  status: boolean;
};

export type UpdateStatusDTO = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  fileId: number;
  status: InboxEntryStatus;
};

const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId/attachments/:fileId`;

export const updateEmailFileStatus = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
  status,
}: UpdateStatusDTO): Promise<UpdateEmailFileEntryResponse> => {
  return axios.put(generateRoutePath(url, { projectId, inboxEntryId, emailId, fileId }), {
    status,
  });
};
